import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=0f52f3c5&scoped=true&"
import script from "./OrderData.vue?vue&type=script&lang=js&"
export * from "./OrderData.vue?vue&type=script&lang=js&"
import style0 from "./OrderData.vue?vue&type=style&index=0&id=0f52f3c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52f3c5",
  null
  
)

export default component.exports